import { fontFamilyBlackerDisplay, fontFamilyMonserrat, gecinaBlueMain, gecinaBrownMain } from '../../../theme'
import { Box } from '@mui/material'
import liens from '../../../enum/liens'
import { filtresListeAvisResponseEnum } from '../../listeAvis/enums/listeAvisEnum'
import React from 'react'
import { ListeAvisResponseModel } from '../../listeAvis/types/filtresListeAvisModel'
import { useNavigate } from 'react-router-dom'

interface BandeauAvisATraiterProps {
	avis: ListeAvisResponseModel
}

type AcceptingProps = BandeauAvisATraiterProps

const BandeauAvisATraiter: React.FC<AcceptingProps>  = (
	{
		avis
	}
) => {
	const navigate = useNavigate()

	return <Box sx={{ background: gecinaBlueMain, minHeight: '192px', paddingX: '172px' }}>
		<Box onClick={() => navigate(liens.avis, { state: { rafraichir: true } })}
		     sx={{
			     width: 'fit-content',
			     fontFamily: fontFamilyMonserrat,
			     fontSize: 16,
			     color: gecinaBrownMain,
			     display: 'flex',
			     flexDirection: 'row',
			     paddingTop: '21px',
			     '&:hover': { cursor: 'pointer' }
		     }}
		>
			<img src="/img/back_arrow.png" height={20} alt="Retour" />
			<Box sx={{ marginLeft: '10px' }}>Retour à la liste</Box>
		</Box>

		<Box sx={{ paddingTop: '22px', fontFamily: fontFamilyBlackerDisplay, fontSize: 28, fontWeight: 900 }}>
			{avis![filtresListeAvisResponseEnum.reference]}
		</Box>

		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				paddingTop: '40px',
				fontFamily: fontFamilyMonserrat
			}}
		>
			<Box>
				<Box sx={{ fontSize: 12 }}>Département</Box>
				<Box sx={{ fontWeight: 600 }}>{avis![filtresListeAvisResponseEnum.departement]}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Commune</Box>
				<Box sx={{ fontWeight: 600 }}>{avis![filtresListeAvisResponseEnum.commune]}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Date d'établissement</Box>
				<Box sx={{ fontWeight: 600 }}>{new Date(avis![filtresListeAvisResponseEnum.dateComptable]).toLocaleDateString()}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Date limite de paiement</Box>
				<Box sx={{ fontWeight: 600 }}>{new Date(avis![filtresListeAvisResponseEnum.dateExigibilite]).toLocaleDateString()}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Statut</Box>
				<Box sx={{ fontWeight: 600 }}>{avis![filtresListeAvisResponseEnum.statut]}</Box>
			</Box>
		</Box>
	</Box>
}

export default BandeauAvisATraiter